import $ from "jquery";
import PropTypes from "prop-types";
import React, { createRef } from "react";
import { connect } from "react-redux";
import { appConfig } from "../../../config/appConfig";
import MenuItem from "./MenuItem";

const filterByUserTypes = (item, userTypes) => {
  if (item.userTypes && !item.userTypes.some((userType) => userTypes.includes(userType))) {
    return null;
  }
  const next = { ...item };
  if (item.items) {
    next.items = item.items.map((child) => filterByUserTypes(child, userTypes)).filter(Boolean);
    if (!next.route && next.items.length === 0) {
      return null;
    }
  }
  return next;
};

class Menu extends React.Component {
  ulRef = createRef(null);

  componentDidMount() {
    const defaults = {
      accordion: true,
      speed: appConfig.menu_speed,
      closedSign: "[+]",
      openedSign: "[-]",
    };
    // Extend our default options with those provided.
    const opts = $.extend({}, defaults, this.props);
    //Assign current element to variable, in this case is UL element
    const $this = $(this.ulRef.current);

    //add a mark [+] to a multilevel menu
    $this.find("li").each(function () {
      if ($(this).find("ul").length !== 0) {
        //add the multilevel sign next to the link
        $(this)
          .find("a:first")
          .append("<b class='collapse-sign'>" + opts.closedSign + "</b>");

        //avoid jumping to the top of the page when the href is an #
        if ($(this).find("a:first").attr("href") === "#") {
          $(this)
            .find("a:first")
            .on("click", (e) => {
              e.preventDefault();
            });
        }
      }
    });

    //open active level
    $this.find("li.active").each(function (li) {
      $(this).parents("ul").slideDown(opts.speed);
      $(this).parents("ul").parent("li").find("b:first").html(opts.openedSign);
      $(this).parents("ul").parent("li").addClass("open");
    });

    $this.find("li a").on("click", function () {
      if ($(this).attr("href") === "#") {
        const $li = $(this).parent("li");
        $li.toggleClass("active", $li.find("ul:visible li.active").length > 0);
      } else {
        $this.find('li.active:has(> a[href="#"])').removeClass("active");
      }

      if ($(this).parent().find("ul").length !== 0) {
        if (opts.accordion) {
          if (!$(this).parent().find("ul").is(":visible")) {
            const parents = $(this).parent().parents("ul");
            const visible = $this.find("ul:visible");
            visible.each(function (visibleIndex) {
              let close = true;
              parents.each(function (parentIndex) {
                if (parents[parentIndex] === visible[visibleIndex]) {
                  close = false;
                  return false;
                }
              });
              if (close) {
                if ($(this).parent().find("ul") !== visible[visibleIndex]) {
                  const $li = $(this).parent("li");
                  const ulIsVisible = $li.find("ul").is(":visible");
                  const ulHasLiActive = $li.find("ul li.active").length !== 0;
                  $li.toggleClass("active", ulIsVisible && ulHasLiActive);

                  $(visible[visibleIndex]).slideUp(opts.speed, function () {
                    $li.find("b:first").html(opts.closedSign);
                    $li.removeClass("open");
                  });
                }
              }
            });
          }
        }
        if ($(this).parent().find("ul:first").is(":visible")) {
          $(this)
            .parent()
            .find("ul:first")
            .slideUp(opts.speed, function () {
              $(this).parent("li").removeClass("open");
              $(this).parent("li").find("b:first").delay(opts.speed).html(opts.closedSign);
            });
        } else {
          $(this)
            .parent()
            .find("ul:first")
            .slideDown(opts.speed, function () {
              $(this).parent("li").addClass("open");
              $(this).parent("li").find("b:first").delay(opts.speed).html(opts.openedSign);
            });
        }
      }
    });
  }

  render() {
    const items = this.props.items.map((item) => filterByUserTypes(item, this.props.userTypes)).filter(Boolean);
    return (
      <ul ref={this.ulRef}>
        {items.map((item) => {
          return <MenuItem item={item} key={item.id} />;
        })}
      </ul>
    );
  }
}
Menu.propTypes = {
  items: PropTypes.array.isRequired,
  userTypes: PropTypes.array,
};

const mapStateToProps = (state) => ({
  items: state.navigation.items,
  userTypes: state.auth.userInfo?.userTypes || [],
});

export default connect(mapStateToProps)(Menu);
